<div class="bubble" [ngClass]="message.role">
    <div class="avatar">{{ message.role === 'user' ? 'U' : 'AI' }}</div>
    <div class="content">
      <div class="text" [innerHTML]="renderedHtml"></div>
      <span class="cursor" *ngIf="message.isStreaming">▋</span>
    </div>
  </div>